import { Component, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MergeFCService } from '../services/raintree/Transmission/merge-fc.service';
import { LoaderComponent } from '../common-component/loader/loader.component';
import { ToastrService } from 'ngx-toastr';
import { MergePopupComponent } from './merge-popup/merge-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { FCMergeResponse } from '../services/raintree/interfaces/fc-merge.interface';
import { response } from 'express';
import { MergeHistoryComponent } from './merge-history/merge-history.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-fc-merge',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, LoaderComponent, CommonModule],
  templateUrl: './fc-merge.component.html',
  styleUrl: './fc-merge.component.scss',
})
export class FcMergeComponent implements OnInit {
  constructor(
    public mergeFCService: MergeFCService,
    public toaster: ToastrService,
    public dialog: MatDialog
  ) {}
  searchReq = new FormControl('');
  isLoading: boolean = false;
  resData: any = null;
  memberList: any = [];
  allowedKeys: any[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
  // primaryFC: any[] = [];
  // secondaryFC: any = [];
  fcDetails: any[] = [];
  statusCodes: any[] = [
    { id: 2, status: 'DA Approved' },
    { id: 3, status: 'DA Rejected' },
    { id: 4, status: 'SU Approved' },
    { id: 5, status: 'SU Rejected' },
    { id: 1, status: 'FC Pending For Review' },
  ];
  ngOnInit(): void {}
  onClick() {
    this.isLoading = true;
    this.mergeFCService.fetchDataBySlNo(this.searchReq.value).subscribe({
      next: (response: FCMergeResponse) => {
        this.isLoading = false;
        if (response.data.memberDetails) {
          this.resData = response.data.memberDetails;
          if (
            response.data.FCdata.length === 0 &&
            response.data.memberDetails.mem_family_code != null
          ) {
            this.isLoading = false;
            // this.fcDetails = [response.data.memberDetails.mem_family_code];
            this.memberList = [
              {
                mem_name: response.data.memberDetails.mem_full_name,
                family_code: response.data.memberDetails.mem_family_code,
                member_code: response.data.memberDetails.phl_member_code,
                last_istavrity_date:
                  response.data.memberDetails.last_istavrity_date,
                phl_mem_name: response.data.memberDetails.phl_mem_name,
                phl_mem_surname: response.data.memberDetails.phl_mem_surname,
                merged: false,
              },
            ];
            console.log(this.memberList, 'fc list');
            // this.statusCodes.forEach((item: any) => {
            //   if (item.id === response.data.memberDetails.record_status) {
            //     this.memberList[0].currentStatus = item.status;
            //   }
            // });
          } else {
            this.fcDetails = response.data.FCdata;
            // this.memberList.filter(
            //   (item: { primary_flag: number; family_code: any }) => {
            //     console.log(item);
            // if (item.primary_flag == 1)
            // this.fcDetails.push(item.family_code);
            // else this.secondaryFC.push(item.family_code);
            // }
            // );
            const statusMap = new Map(
              this.statusCodes.map((item) => [item.id, item.status])
            );

            // Iterate over array2 and add the new key based on the condition
            this.fcDetails = this.fcDetails.map(
              (item: { record_status: any }) => {
                if (statusMap.has(item.record_status)) {
                  return {
                    ...item,
                    status: statusMap.get(item.record_status),
                  };
                }
                return item;
              }
            );
          }
          console.log(this.fcDetails, 'fc details');
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.toaster.clear();
        this.toaster.error(error);
      },
    });
  }
  // this.resData = null;

  onMergeHistory() {
    this.isLoading = true;
    this.mergeFCService.fetchMergeHistory().subscribe({
      next: (response) => {
        if (!response.error && response.data.length > 0) {
          this.isLoading = false;

          this.dialog.open(MergeHistoryComponent, {
            data: response.data,
          });
        } else {
          this.isLoading = false;
          this.toaster.success('No Data Found');
        }
      },

      error: (error) => {
        this.isLoading = false;
        this.toaster.error(error);
      },
    });
  }
  mergeHistoryData: any = {};

  onMergeClick() {
    console.log(this.memberList.length, this.fcDetails, 'component');
    let details =
      this.memberList.length === 0 ? this.fcDetails : this.memberList;
    console.log(details, 'details');
    this.dialog.open(MergePopupComponent, {
      data: {
        slNo: this.searchReq.value,
        fcList: details,
        resData: this.resData,
        // fc: [...this.primaryFC, this.secondaryFC],
      },
    });
  }
  restrictSLInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;
    const pattern = /^[0-9]*$/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    // if (!pattern.test(input) || limit.value.length > 8) {
    //   event.preventDefault(); // Prevent input if it doesn't match the pattern
    // }
  }
}
